var _line, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_78873",
    "data-name": "Group 78873",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 26,
    transform: "translate(22.5 26) rotate(-90)",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78866",
    "data-name": "Group 78866",
    transform: "translate(0 22.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146277",
    "data-name": "Rectangle 146277",
    width: 9,
    height: 21,
    rx: 1,
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146278",
    "data-name": "Rectangle 146278",
    width: 9,
    height: 11,
    rx: 1,
    transform: "translate(11 10)",
    fill: "#828282"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.bf54d9fa064ad0ddae0678917721322b.svg";
export { ForwardRef as ReactComponent };